<!-- Loading bar -->
<loading-bar></loading-bar>

<!-- Header — dark anthracite bar matching sidebar -->
<div class="zt-header relative flex flex-0 items-center w-full h-14 px-4 md:px-6 z-49 border-b border-white/[0.06] print:hidden">

    <!-- Logo -->
    <div class="flex items-center gap-2.5">
        <div class="w-9 h-9 flex items-center justify-center">
            <img src="assets/images/logo/logo.png" class="w-full h-full object-contain" alt="Zeitune">
        </div>
        <span class="text-lg font-bold tracking-tight text-white">
            Zeitune
        </span>
    </div>

    <!-- Right actions -->
    <div class="flex items-center ml-auto gap-1">
        <languages></languages>
        <notifications></notifications>
        <user></user>
    </div>
</div>

<!-- Content wrapper — rounded top-left for smooth dark-to-light transition -->
<div class="flex-1 flex flex-col min-h-0 bg-[#f8f9fb] rounded-tl-2xl overflow-hidden shadow-[-4px_-2px_24px_-12px_rgba(0,0,0,0.08)]">
    <div class="flex-1 overflow-auto">
        <div class="max-w-screen-xl mx-auto px-4 md:px-6 pt-4">
            <router-outlet *ngIf="true"></router-outlet>
        </div>
    </div>
</div>
